
import { Options, Vue } from "vue-class-component";

@Options({
  name: "MainLayout",
  components: {},
})
export default class MainLayout extends Vue {}
